export default "__VITE_ASSET__ff1e1496__"